import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid-pro";
import { Typography } from "@mui/material";
// import { faL } from "@fortawesome/pro-solid-svg-icons";
import React, { useState } from 'react';
import Api from "../../services/Api";
import { RootState } from "../../util/store";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { useAppSelector } from "../../util/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAlertDispatch } from '../../context/AlertContext/AlertContext';
import { useGridApiContext, gridFilterModelSelector } from '@mui/x-data-grid';
  
export interface CustomGridToolbarProps {
    resultCount: number;
    fullResults: boolean;
    retrievedTS?: string;
}

export default function CustomGridToolbar(props: CustomGridToolbarProps): JSX.Element {
    const apiRef = useGridApiContext();
    const alertDispatch = useAlertDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const isCSV = window.location.toString().includes("inventory");
    const basicSearchCsv = useAppSelector((state: RootState) => state.inventory.basicSearchCsv);
    
    const removeNestedEmpty:any = (obj:any) =>  {
        return Object.entries(obj)
          .filter(([_, v]) => v != '' )
          .reduce(
            (acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? removeNestedEmpty(v) : v }),
            {}
          );        
      }

    const removeEmpty = (obj:any) => {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];
        const value = obj[key];
        if (
        value === null ||
        value === undefined ||
        value === "" ||
        JSON.stringify(value) === "{}"
        ) {
        delete obj[key];
        }
    }
    return obj;
    };

    const handlerCsvClick = async () => {
        try {
            if(window.location.toString().includes("inventory") && props?.resultCount && props.resultCount > 0){
                setIsLoading(true);
                const filterModel = gridFilterModelSelector(apiRef);
                const params = removeEmpty(removeNestedEmpty({
                    ...basicSearchCsv.params,
                    filterModel: filterModel // Include the grid filters
                }));
                const api = new Api("");
                const result = await api.getInventoryCsvData(params);
                const data = new Blob([result], { type: "text/csv" });
                const csvURL = window.URL.createObjectURL(data);
                const tempLink = document.createElement("a");
                tempLink.href = csvURL;
                tempLink.setAttribute("download", "inventory.csv");
                document.body.appendChild(tempLink);
                tempLink.click();
                setIsLoading(false);
            }else{
                alertDispatch({
                    type: 'add',
                    payload: {
                        type: "general",
                        message: "No Data Found. Please Click Search Button To Download Data.",
                    }
                });
            }          
        } catch (err:any) {
            setIsLoading(false);
            alertDispatch({
                type: 'add',
                payload: {
                    type: "general",
                    message: "Error: "+ (Object.keys(err).length === 0 ? err : JSON.stringify(err)),
                }
            });
        }        
    }

    const handlePrintClick = () => {
      apiRef.current.exportDataAsPrint({
        hideFooter: true,
        hideToolbar: true,
      });
    };   
    
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          printOptions={{
            hideFooter: true,
            hideToolbar: true,
            disableToolbarButton: isCSV ? true : false
          }}
          csvOptions={{ disableToolbarButton: isCSV ? true : false }}
          startIcon={null}
        />
        {isCSV && (
          <>
            <Button
              onClick={handlePrintClick}
              size="small"
            >
              Print
            </Button>
          </>
        )}
        {isCSV && (
          <>
            <LoadingButton
              onClick={handlerCsvClick}
              loading={isLoading}
              loadingPosition="start"
              size="small"
            >
              {isLoading ? `Generating CSV` : `Download CSV`}
            </LoadingButton>
          </>
        )}        
        {props.resultCount === 5000 && !props.fullResults && (
          <Typography
            variant="caption"
            color="secondary"
            sx={{ flex: 1, textAlign: "center" }}
          >
            Working with partial results - select "Show full results" in search
            page to show all
          </Typography>
        )}
        {props.retrievedTS !== undefined && props.retrievedTS !== "" && (
          <Typography
            variant="caption"
            color="secondary"
            sx={{ flex: 1, textAlign: "center" }}
          >
            Results retrieved at {props.retrievedTS}
          </Typography>
        )}
      </GridToolbarContainer>
    );
}
